export default {
  addDetails: {
    id: 'bo_seller_profile_page_epr_block_add_details',
    defaultMessage: 'Add details',
  },
  category: {
    id: 'bo_seller_profile_page_epr_block_category',
    defaultMessage: 'Category',
  },
  mandatory: {
    id: 'bo_seller_profile_page_epr_block_mandatory',
    defaultMessage: 'Mandatory',
  },
  optional: {
    id: 'bo_seller_profile_page_epr_block_optional',
    defaultMessage: 'Optional',
  },
  eprNumber: {
    id: 'bo_seller_profile_page_epr_block_epr_number',
    defaultMessage: 'EPR number',
  },
  downloadButton: {
    id: 'bo_seller_profile_page_epr_block_download_button',
    defaultMessage: 'Download document',
  },
  eprSubTitleFR: {
    id: 'bo_seller_profile_page_epr_block_epr_subtitle_fr',
    defaultMessage: 'Add your EPR details to avoid additional fees.',
  },
  eprSubTitleDE: {
    id: 'bo_seller_profile_page_epr_block_epr_subtitle_de',
    defaultMessage: 'Add your EPR details to sell in Germany.',
  },
  exempt: {
    id: 'bo_seller_profile_page_epr_block_exempt',
    defaultMessage: 'Exempt',
  },
  termsAndConditions: {
    id: 'bo_seller_profile_page_epr_block_terms_conditions',
    defaultMessage: 'Read about these fees in our Terms and Conditions',
  },
  fullDeeeLabel: {
    id: 'bo_seller_profile_page_epr_block_full_deee_label',
    defaultMessage: 'Waste from Electrical and Electronic Equipment (WEEE)',
  },
}
